module.exports = __webpack_public_path__ + "img/title@2x.367a6e59.png";